import { AfterViewInit, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { RequestType, StorageConstants } from 'common/constants/app.constant';
import { RouteMessage } from 'common/models/utilitymodels/base.model';
import { SystemService } from 'common/services/core_services/system.service';
import { NavigateRoutes } from 'common/constants/app.constant';
import { ActivatedRoute, Router } from '@angular/router';
import { WelcomeWidgetService } from 'common/services/component_services/welcome/welcome.widget.service';
import { BaseViewPage } from 'common/pages/base/base.view.page';
import { WelcomeListingModel, WelcomeMetaModel } from 'common/models/pagemodels/welcome/welcome.model';
import { NgbScrollSpyService } from '@ng-bootstrap/ng-bootstrap';

import { WelcomeResolver } from 'common/resolvers/welcome/welcome.resolver';

@Component({
    selector: 'app-welcome',
    templateUrl: './welcome.page.html',
})
export class WelcomePage extends BaseViewPage<WelcomeListingModel, WelcomeMetaModel> implements AfterViewInit {
    routes = NavigateRoutes;
    viewHeight: number = 0;
    currentSlide: number = 1;
    intervalID: any;
    sliderPerView: number = 3;
    showSticky: boolean = false;
    showTestimonial = true;

    constructor(
        protected override activatedRoute: ActivatedRoute,
        protected widgetService: WelcomeWidgetService,
        protected override systemService: SystemService,
        protected router: Router,
        private cdr: ChangeDetectorRef,
        private welcomeResolver: WelcomeResolver
    ) {
        super(activatedRoute, widgetService, systemService, router);
    }

    ngOnInit(): void {
        this.welcomeResolver.resolve().then((data) => {
            this.systemService.loading.next(false);
            this.systemService.removeLocalStorage(StorageConstants.userProfile);
            this.systemService.removeLocalStorage(StorageConstants.kbhAccessToken);
            this.systemService.removeLocalStorage(StorageConstants.kbhRefreshToken);
            this.systemService.removeSessionStorage(StorageConstants.zeroAUMValue);
            this.systemService.removeSessionStorage(StorageConstants.isPreLoginInitiat);
            this.systemService.isPriLoginTransaction = false;

            this.systemService.removeLocalStorage(StorageConstants.isEmployeeLogin);
            this.listpageData = data['data'];
            this.listpageMeta = data['meta'];
            this.listComponentData = data['componentData'];
        });
    }

    ngAfterViewInit(): void {
        if (this.systemService.deviceInfo?.platform === 'web') {
            window.addEventListener('resize', (ev) => {
                const swiperEl = document.querySelector('swiper-container');
                if (swiperEl !== null) {
                    swiperEl.setAttribute('autoplay', 'true');
                    swiperEl.setAttribute('loop', 'false');
                    swiperEl.setAttribute('pagination', 'true');
                    swiperEl.setAttribute('data-swiper-autoplay', '3000'); // Set the delay in milliseconds
                    swiperEl.setAttribute('data-swiper-disable-on-interaction', 'false');
                    if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
                        swiperEl.setAttribute('slides-per-view', '2');
                    }

                    if (window.innerWidth > 1024) {
                        this.showTestimonial = false;
                        swiperEl.setAttribute('slides-per-view', '3');
                        this.showTestimonial = true;
                    }

                    if (window.innerWidth < 768) {
                        swiperEl.setAttribute('slides-per-view', '1');
                    }
                }
            });

            const scrollContent = document.querySelector('.welcome-other-content');

            if (scrollContent !== null) {
                scrollContent.addEventListener(
                    'scroll',
                    () => {
                        scrollContent.scrollTop > window.innerHeight - 100 ? (this.showSticky = true) : (this.showSticky = false);
                    },
                    { passive: true }
                );
            }

            this.intervalID = setInterval(() => {
                const elements = document.querySelectorAll('.sl-img');

                let temp = this.currentSlide + 1;

                if (this.currentSlide === 4) {
                    this.currentSlide = 1;
                    //remove
                    elements[0].classList.remove('position2');
                    elements[1].classList.remove('position3');
                    elements[2].classList.remove('position4');
                    elements[3].classList.remove('position1');
                    //add
                    elements[0].classList.add('position1');
                    elements[1].classList.add('position2');
                    elements[2].classList.add('position3');
                    elements[3].classList.add('position4');
                    return;
                }

                if (temp === 2) {
                    //remove
                    elements[0].classList.remove('position1');
                    elements[1].classList.remove('position2');
                    elements[2].classList.remove('position3');
                    elements[3].classList.remove('position4');
                    //add
                    elements[0].classList.add('position4');
                    elements[1].classList.add('position1');
                    elements[2].classList.add('position2');
                    elements[3].classList.add('position3');
                } else if (temp === 3) {
                    //remove
                    elements[0].classList.remove('position4');
                    elements[1].classList.remove('position1');
                    elements[2].classList.remove('position2');
                    elements[3].classList.remove('position3');
                    //add
                    elements[0].classList.add('position3');
                    elements[1].classList.add('position4');
                    elements[2].classList.add('position1');
                    elements[3].classList.add('position2');
                } else if (temp === 4) {
                    //remove
                    elements[0].classList.remove('position3');
                    elements[1].classList.remove('position4');
                    elements[2].classList.remove('position1');
                    elements[3].classList.remove('position2');
                    //add
                    elements[0].classList.add('position2');
                    elements[1].classList.add('position3');
                    elements[2].classList.add('position4');
                    elements[3].classList.add('position1');
                }

                this.currentSlide += 1;
            }, 3000);

            if (this.systemService.deviceInfo?.platform === 'web') {
                this.viewHeight = window.innerHeight - 70;
                document.body.classList.add('add-overflow-none');

                if (window.innerWidth > 768 && window.innerWidth < 992) {
                    this.viewHeight = window.innerHeight;
                }
            }
            this.cdr.detectChanges();
        } else {
            this.systemService.loading.next(false);
        }
    }

    ngOnDestroy(): void {
        if (this.systemService.deviceInfo?.platform === 'web') {
            clearInterval(this.intervalID);
            window.removeEventListener('resize', () => { });
            document.querySelector('.welcome-other-content')?.removeEventListener('scroll', () => { });

            if (document.body.classList.contains('add-overflow-none')) {
                document.body.classList.remove('add-overflow-none');
            }
        }

        document.body.classList.remove('no-wrapper-padd');
    }

    clickOnVideo(video: any) {
        this.listpageData.curruntSelectedVideo = video;
        this.listpageMeta.properties.showModal = true;
    }

    onCloseModal() {
        this.listpageMeta.properties.showModal = false;
        this.systemService.dismissPopup();
    }

    navigate(url: string, postLoginRedirection: string = '') {
        const routeMsg = new RouteMessage();
        routeMsg.type = RequestType.BLANK;
        routeMsg.transferData = {
            postLoginRedirection,
        };
        this.systemService.routeByUrl(url, routeMsg);
    }

    goToEmpanelment(type: 'empanelment') {
        const routeMsg = new RouteMessage();
        routeMsg.type = RequestType.BLANK;
        routeMsg.transferData = null;
        this.systemService.routeByUrl(NavigateRoutes.empanelment, routeMsg);
    }

    getYoutubeThumbnail(url: string): string {
        return this.systemService.getYoutubeThumbnail(this.youtubeParser(url));
    }

    youtubeParser(url: string): string {
        if (!url) {
            return 'null';
        }
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url.match(regExp);
        return match && match[7].length == 11 ? match[7] : 'false';
    }
}
